package com.kinoshazam.screens.profile.expanded

import androidx.compose.runtime.Composable
import com.kinoshazam.screens.profile.compact.CompactProfileContent
import presentation.screens.profile.ProfileMVIAction
import presentation.screens.profile.ProfileState

@Composable
actual fun ExpandedProfileContent(
    state: ProfileState,
    onAction: (ProfileMVIAction) -> Unit,
) {
    CompactProfileContent(state = state, onAction = onAction)
}
